<template>
  <div style="height: calc(100% - 175px)">
    <div class="copySel">
      <!-- <span class="copyLab">语言</span>
            <form-select1 
            v-model="lang"
            :options="$getOptions('lang')"
            @change="langChange"
            >
            </form-select1> -->
      <!-- <span class="copyLab">查询类型</span>
            <form-select1 
                labelWidth="120px"
                v-model="type"
                :options="$getOptions('queryType')"
                @change="typeChange">
            </form-select1> -->

      <base-form
        ref="queryForm"
        class=""
        v-model="baseQueryFormObj"
        labelWidth="120px"
        :inline="true"
        :form-items="baseFormItems"
      >
      </base-form>
      <el-button
        style="margin-left: 100px"
        size="small"
        type="primary"
        @click="showImportDialog = true"
        >数据导入</el-button
      >
      <el-button
        style="margin-left: 20px"
        size="small"
        type="primary"
        @click="delData"
        >删除查询数据</el-button
      >
    </div>
    <base-form
      ref="queryForm"
      class=""
      v-model="queryFormObj"
      labelWidth="120px"
      :inline="true"
      @keyup.enter.native="enterQuery"
      :form-items="toolbar.formItems"
    >
    </base-form>
    <base-table
      :sendJson="true"
      ref="table"
      :query="queryFormObj"
      :initSearch="false"
      :actionReload="true"
      url="/queryData/get"
      :responseHandler="responseHandler"
      :columns="columns"
    >
    </base-table>
    <import-data-dialog
      v-model="showImportDialog"
      @closeDiag="closeDiag"
    ></import-data-dialog>
  </div>
</template>
<script>
export default {
  name: 'import-data',
  data() {
    var brandQueryForm = {
      label: '  列表类别',
      prop: 'bid',
      labelWidth: '200px',
      component: 'form-select1',
      bind: {
        param: {
          data_type: 1,
        },
        clearable: true,
        sendJson: true,
        dataKey: {
          label: 'brand',
          value: 'id',
        },
      },
      on: {
        change: this.brandChange,
      },
    }
    return {
      showImportDialog: false,
      currSelectIdx: -1,
      userArr: [],
      queryFormObj: {
        showDisabledField: true
      },
      baseQueryFormObj: {},
      // type:'',
      uploaderData: { type: 'codingQuery', userName: this.$root.getNickName() },
      brandQueryForm: brandQueryForm,
      baseFormItems: [
        {
          label: '查询类型',
          prop: 'type',
          component: 'form-select',
          bind: {
            options: this.$getOptions('queryType'),
          },
          on: {
            change: this.typeChange,
          },
        },
        brandQueryForm,
      ],
      toolbar: {
        formItems: [],
        query: {},
      },
      columns: [],
    }
  },
  methods: {
    enterQuery() {
      this.$refs.table.query.PageIndex = 1
      this.$refs.table.refreshData()
    },
    closeDiag() {
      this.showImportDialog = false
      this.$refs.table.refreshData()
    },
    responseHandler(resp) {
      if (resp.data.code == 0) {
        var data = resp.data.data.Data || []
        this.$refs.table.setTableData({
          rows: data,
          total: resp.data.data.Total,
        })
        //查询options数据
        this.queryOptions()
        // var formItems=this.toolbar.formItems;
        // for(var item of formItems){
        //     var optionsArr=[],keyArr=[];
        //     for(var obj of data){
        //         var optionObj=obj[item.prop];
        //         if(optionObj){
        //             if(keyArr.indexOf(optionObj)<0){
        //                 keyArr.push(optionObj);
        //                 optionsArr.push({
        //                     label:optionObj,
        //                     value:optionObj
        //                 })
        //             }
        //         }
        //     }
        //     item.bind.options=optionsArr;
        // }
      }
    },
    typeChange(val) {
      var that = this
      this.uploaderData.type = this.brandQueryForm.type
      var firstFormItem = { ...this.brandQueryForm }
      firstFormItem.bind.url = '/brandOrField/get'
      firstFormItem.bind.param.type = val
      firstFormItem.value = ''
      this.toolbar.formItems = []
      this.columns = []
      this.baseFormItems.splice(1, 1)
      this.$nextTick(() => {
        this.baseFormItems[0].value = val
        this.baseFormItems.push(firstFormItem)
      })
    },
    queryOptions(data) {
      var i = 0
      var formItems = this.toolbar.formItems
      if (!data) {
        var fields = []
        for (var item of formItems) {
          if (this.currSelectIdx < 0 || i > this.currSelectIdx) {
            if (item.component == 'form-select') {
              fields.push(item.prop)
            }
          }
          i++
        }
        if (fields.length == 0) return
        data = { ...this.queryFormObj, fields: fields.join(',') }
        delete data['PageSize']
        delete data['PageIndex']
      }
      var that = this
      var url = '/queryData/getFileDisdData'
      that.$postObj(url, data).then(function (resp) {
        if (resp.data.code == 0) {
          var data = resp.data.data
          i = 0
          for (var item of formItems) {
            if (that.currSelectIdx < 0 || i > that.currSelectIdx) {
              item.bind.options = []
              var optionsArr = data[item.prop]
              if (optionsArr) {
                for (var optionObj of optionsArr) {
                  if (optionObj) {
                    item.bind.options.push({
                      label: optionObj,
                      value: optionObj,
                    })
                  }
                }
              }
            }
            i++
          }
        } else {
          that.$message(resp.data.msg)
        }
      })
    },
    brandChange(objVal) {
      if (!objVal.val) {
        this.toolbar.formItems = []
        this.columns = []
        return
      }
      var that = this
      var url = '/brandOrField/getFiled'
      var data = {
        bid: objVal.val,
        showDisabledField: true
      }
      that.$post(url, data).then(function (resp) {
        if (resp.data.code == 0) {
          that.currSelectIdx = -1
          var data = resp.data.data
          if (data && data.length > 0) {
            that.queryFormObj = {
              PageIndex: that.queryFormObj.PageIndex,
              PageSize: that.queryFormObj.PageSize,
            }
            that.brandQueryForm.value = objVal.val
            var clum = [],
              queryFormItem = []
            var fields = data
            var strs = ''
            var i = 0
            for (var obj of fields) {
              if (obj.query_clum) {
                if (obj.ele_type) {
                  queryFormItem.push({
                    label: obj.clum_desc,
                    prop: obj.clum_name,
                    labelWidth: '100px',
                    bind: {
                      style: 'min-width:210px;max-width:260px;',
                    },
                    on: {
                      blur: () => {
                        that.$refs.table.query.PageIndex = 1
                        that.$refs.table.refreshData()
                        that.queryOptions()
                      },
                    },
                  })
                } else {
                  var changeEvt = function (val) {
                    that.currSelectIdx = this
                    that.queryFormObj[
                      that.toolbar.formItems[that.currSelectIdx].prop
                    ] = val
                    for (
                      var j = that.currSelectIdx + 1;
                      j < that.toolbar.formItems.length;
                      j++
                    ) {
                      if (
                        that.toolbar.formItems[j].component == 'form-select'
                      ) {
                        that.queryFormObj[that.toolbar.formItems[j].prop] = ''
                      }
                    }
                    that.$refs.table.query.PageIndex = 1
                    that.$refs.table.refreshData()
                    that.queryOptions()
                  }
                  queryFormItem.push({
                    label: obj.clum_desc,
                    prop: obj.clum_name,
                    labelWidth: '100px',
                    value: '',
                    component: 'form-select',
                    bind: {
                      clearable: true,
                      options: [],
                    },
                    on: {
                      change: changeEvt.bind(i), //.native
                      // "visible-change":(val)=>{
                      //     if(val){
                      //         var sels=document.getElementsByClassName("el-select-dropdown el-popper");
                      //         sels[sels.length-1].style["min-width"]="210px";
                      //         sels[sels.length-1].style["max-width"]="260px";
                      //     }else{
                      //         setTimeout(()=>{
                      //             that.removeReadOnly();
                      //         },50);
                      //     }
                      // },
                    },
                  })
                  // strs+=","+obj.clum_name
                }
                i++
              }
              clum.push({
                bind: {
                  label: obj.clum_desc,
                  prop: obj.clum_name,
                }
              })
            }
            that.toolbar.formItems = queryFormItem
            that.columns = clum
            that.$nextTick(() => {
              that.$refs.table.query.bid = that.baseQueryFormObj.bid
              //刷新数据
              that.$refs.table.refreshData()
              // var data={
              //     bid:objVal.val,
              //     fields:strs.substring(1)
              // };
              // //查询options数据
              // that.queryOptions(data);
            })
          }
        } else {
          that.$message(resp.data.msg)
        }
      })
    },

    delData(scope) {
      if (confirm('确定删除查询列表数据?')) {
        if (!this.baseQueryFormObj.bid) {
          this.$message('请选择列表类别')
          return
        }
        var data = { ...this.queryFormObj }
        data.bid = this.baseQueryFormObj.bid
        delete data['PageSize']
        delete data['PageIndex']
        this.$postObj('/queryData/removeData', data)
          .then((resp) => {
            if (resp.data.code == 0) {
              this.$refs.table.refreshData()
              this.$message({
                type: 'success',
                message: '删除成功',
              })
            } else {
              console.error(resp)
              this.$message(
                resp.data.msg || this.$getMsg(resp.data.code, '服务端处理失败')
              )
            }
          })
          .catch((error) => {
            // 请求失败处理
            console.error(error)
            this.$message('请求发生错误！')
          })
      }
    },
  },
  watch:{
    queryFormObj: function(newVal, oldVal){
      this.queryFormObj.showDisabledField = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.copySel {
  display: flex;
  height: 30px;
  padding: 20px 0px;
}

.copyLab {
  margin-left: 54px;
  margin-right: 10px;
  padding-top: 5px;
  text-align: right;
  font-size: 14px;
  color: #606266;
}
</style>